type VideoWithAudioHints = HTMLVideoElement & {
  audioTracks?: {
    length: number;
  };
  mozHasAudio?: boolean;
  webkitAudioDecodedByteCount?: number;
};
const videoHasAudioTrack = (video: HTMLVideoElement): boolean => {
  const videoWithHints = video as VideoWithAudioHints;
  if (videoWithHints.audioTracks && videoWithHints.audioTracks.length > 0) {
    return true;
  }
  if (videoWithHints.mozHasAudio) {
    return true;
  }
  if (typeof videoWithHints.webkitAudioDecodedByteCount === 'number' && videoWithHints.webkitAudioDecodedByteCount > 0) {
    return true;
  }
  return false;
};
export default videoHasAudioTrack;